import { api } from '../lib/api'

export interface LeaderboardEntry {
  managerId: string
  managerName: string
  daysActive: number
  resolved: number // ações tiradas de "pendente" (por quem agiu)
  eligible: number // ações elegíveis dos clientes do gerente no período
  resolvedEligible: number
  followThroughPct: number | null
  // Contribuições que ensinaram a IA (respostas, fatos, motivos/comentários, achados).
  knowledge: number
  wins: number | null // ações que melhoraram o KPI-alvo (só no placar geral)
  points: number
}

export interface LeaderboardWeights {
  day: number
  followMaxWeek: number
  followMaxMonth: number
  // Placar Geral: peso por vitória (o resto é a soma das pontuações mensais).
  allWin: number
  knowledge: number
  knowledgeMaxWeek: number
  knowledgeMaxMonth: number
}

export interface LeaderboardResp {
  period: 'week' | 'month' | 'all'
  label: string
  hasResults: boolean
  weights: LeaderboardWeights // pesos configuráveis (semana/mensal)
  entries: LeaderboardEntry[]
}

export const leaderboardApi = {
  get: (period: 'week' | 'month' | 'all', month?: 'current' | 'last') => {
    const p = new URLSearchParams({ period })
    if (period === 'month' && month) p.set('month', month)
    return api.get<LeaderboardResp>(`/leaderboard?${p.toString()}`)
  },
}
